import { createContext, useContext } from 'react';
import type { SegregacaoCalcularResponseData } from '@/services/SimplesNacional/Segregacao/api/types';

export type StatusApuracao = 'validado' | 'pendente' | 'fechado';
export type TipoTributacao = 'integral' | 'isento' | 'segregado' | 'imune';
export type SituacaoCompetencia = 'Aberto' | 'Fechado';

export interface MemoriaCalculoItem {
  label: string;
  formula?: string;
  valor: string;
}

export interface ApuracaoSNData {
  competencia: string;
  status: StatusApuracao;
  // RBT12 — virá de endpoint dedicado futuramente
  rbt12: number;
  faixaAtual: string;
  limiteFaixa: number;
  percentualFaixa: number;
  // Anexo / alíquota — derivados de RED
  anexo: string;
  aliquotaNominal: number;
  parcelaADeduzir: number;
  aliquotaEfetiva: number;
  // DAS — derivado de RED
  dasARecolher: number;
  vencimento: string;
  // Totais de receita — derivados de TOT
  receitaBrutaTotal: number;
  receitaTributavel: number;
  memoriaCalculo: MemoriaCalculoItem[];
}

export interface ApuracaoSNContextData {
  dados: ApuracaoSNData;
  segregacao: SegregacaoCalcularResponseData | null;
  isLoading: boolean;
  error: Error | null;
  mostrarZeros: boolean;
  setMostrarZeros: (v: boolean) => void;
  buscar: () => void;
  recalcular: () => void;
  podeCalcular: boolean;
  calculado: boolean;

  situacaoCompetencia: SituacaoCompetencia;
  aguardandoPgdas: boolean;
  isLoadingStatusFechamento: boolean;
  fecharCompetencia: () => void;
  abrirCompetencia: () => void;
  isFechando: boolean;
  isAbrindo: boolean;
}

export const ApuracaoSNContext = createContext<ApuracaoSNContextData | undefined>(undefined);

export function useApuracaoSN(): ApuracaoSNContextData {
  const ctx = useContext(ApuracaoSNContext);
  if (!ctx) throw new Error('useApuracaoSN deve ser usado dentro de ApuracaoSNProvider');
  return ctx;
}
